<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Productor</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <producer-form
          v-if="isDataLoaded"
          :producer="producer"
          :server-errors="serverErrors"
          :title="`Editar productor: ${producer.businessName}`"
          @save="saveProducer"
        >
        </producer-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProducerForm from './Forms/ProducerForm';
import swal from 'sweetalert2';

export default {
  name: 'ProducersEdit',
  components: {
    RouteBreadCrumb,
    ProducerForm,
  },

  data() {
    return {
      isDataLoaded: false,
      serverErrors: [],
      producer: null,
    };
  },

  created() {
    const producerId = this.$route.params.id;
    this.fetchProducer(producerId);
  },

  methods: {
    fetchProducer(producerId) {
      let params = {
        include: ['distributor', 'city.province'],
      };

      this.$services
        .resource('producers')
        .show(producerId, params)
        .then((res) => res.data.data)
        .then((producer) => {
          this.producer = producer;
          this.isDataLoaded = true;
        });
    },

    saveProducer(producer) {
      this.$services
        .resource('producers')
        .update(this.producer.id, producer)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El productor fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => {
            if (!this.$route.query.projection) {
              this.$router.push({ name: 'ProducersList' });
            } else {
              this.$router.push({ name: 'ProjectionShow', params: { id: this.$route.query.projection } });
            }
          });
        })
        .catch((errors) => {
          this.serverErrors = errors;
        });
    },
  },
};
</script>
